

if (!customElements.get('ryu-gift-card')) {
  customElements.define('ryu-gift-card', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.button = this.querySelector('[data-gift-submit]');
      this.message = this.querySelector('textarea');
      this.email = this.form.querySelector('input[name="properties[Recipient email]"]');
      this.emailConfirmation = this.form.querySelector('[data-gift-email-confirm]');
      this.deliveryModes = [...this.form.querySelectorAll('[data-gift-delivery-mode]')];
      this.scheduleFields = this.form.querySelector('[data-gift-schedule-fields]');
      this.sendOn = this.form.querySelector('[data-gift-send-on]');
      this.timezoneOffset = this.form.querySelector('[data-gift-timezone-offset]');
      this.previewImages = [...this.querySelectorAll('[data-gift-image]')];
      this.previewFallback = this.querySelector('[data-gift-fallback]');
      this.setScheduleLimits();
      this.onChange = () => this.update();
      this.onSubmit = (event) => {
        if (this.submitting || !this.form.reportValidity()) {
          event.preventDefault();
          return;
        }

        this.submitting = true;
        this.deliveryModes.forEach((mode) => { mode.disabled = true; });
        this.button.setAttribute('aria-disabled', 'true');
        this.button.setAttribute('aria-busy', 'true');
      };
      this.onPageShow = () => {
        this.submitting = false;
        this.deliveryModes.forEach((mode) => { mode.disabled = false; });
        this.button.removeAttribute('aria-disabled');
        this.button.removeAttribute('aria-busy');
        this.update();
      };
      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('input', this.onChange);
      this.form.addEventListener('submit', this.onSubmit);
      window.addEventListener('pageshow', this.onPageShow);
      this.update();
    }

    disconnectedCallback() {
      if (!this.form) return;
      this.form.removeEventListener('change', this.onChange);
      this.form.removeEventListener('input', this.onChange);
      this.form.removeEventListener('submit', this.onSubmit);
      window.removeEventListener('pageshow', this.onPageShow);
      this.initialized = false;
    }

    formatLocalDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    setScheduleLimits() {
      const today = new Date();
      const finalDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      finalDate.setDate(finalDate.getDate() + 90);
      this.sendOn.min = this.formatLocalDate(today);
      this.sendOn.max = this.formatLocalDate(finalDate);
      this.timezoneOffset.value = String(new Date().getTimezoneOffset());
    }

    update() {
      const emailsMatch = !this.emailConfirmation.value || this.email.value.toLowerCase() === this.emailConfirmation.value.toLowerCase();
      this.emailConfirmation.setCustomValidity(emailsMatch ? '' : 'The email addresses do not match.');
      const scheduled = this.deliveryModes.find((mode) => mode.checked)?.value === 'scheduled';
      this.scheduleFields.hidden = !scheduled;
      this.sendOn.disabled = !scheduled;
      this.sendOn.required = scheduled;
      this.timezoneOffset.disabled = !scheduled;
      const selected = this.form.querySelector('input[name="id"]:checked');
      if (selected) {
        const points = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(Number(selected.dataset.points));
        this.querySelector('[data-gift-preview]').textContent = points;

        const selectedImage = this.previewImages.find((image) => image.dataset.giftVariantId === selected.value);
        this.previewImages.forEach((image) => { image.hidden = image !== selectedImage; });
        this.previewFallback.hidden = Boolean(selectedImage);

        const price = new DOMParser().parseFromString(selected.dataset.price, 'text/html').body.textContent;
        this.querySelector('[data-gift-summary]').textContent = `Pay ${price} for ${points} RyuPoints.`;
      }
      this.querySelector('[data-gift-count]').textContent = this.message.value.length;
    }
  });
}
